module.exports = require('./helpers/bundle-url').getBundleURL('h4RYs') + "logo-dark.eefe0b7f.svg";